import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(@Optional() @Inject('serverUrl') protected serverUrl: string, @Inject(LOCAL_STORAGE) private localStorage: any, ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log("environment.apiBaseUrl", environment.apiBaseUrl);
        const token = this.localStorage.getItem('token');
        if (token) {
            request = request.clone({
                url : `${environment.apiBaseUrl}${request.url}`,
                setHeaders: {
                    'X-Auth-Token': `${token}`
                },
                withCredentials: true
            });
        } else {
            request = request.clone({
                url : `${environment.apiBaseUrl}${request.url}`,
                setHeaders: {},
                withCredentials: true
            });
        }
        return next.handle(request);
    }
}
